// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT = "Naozaj chce\u0161 zmaza\u0165 koment\u00e1r?";
export const DELETE_COMMENT = "Zma\u017e";
export const FORUM_COMMENT_EDIT_MENU = "Uprav";
export const REPLY_LINK = "Odpovedz";
